import { render, staticRenderFns } from "./qr.vue?vue&type=template&id=80bea328"
import script from "./qr.vue?vue&type=script&lang=js"
export * from "./qr.vue?vue&type=script&lang=js"
import style0 from "./qr.vue?vue&type=style&index=0&id=80bea328&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports